<template>
    <div class="chat-body__form-templates">
        <SlideUpDown class="templates-block" :isActive="isActiveTemplates">
            <div class="templates-block__header" :class="{animate: isShowFormTemplate}">
                <div class="templates-block__header-title">
                    <span class="templates-block__header-back" 
                        v-if="isShowFormTemplate && userTemplates.length !== 0" 
                        :class="{animate: isShowFormTemplate}"
                        @click="isShowFormTemplate = false">
                        <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                    </span>
                    <h4 v-if="isShowFormTemplate" :class="{animate: isShowFormTemplate}">{{ isEdit ? $t("Update template") : $t("Create template") }}</h4>
                    <h4 v-else :class="{animate: !isShowFormTemplate}">{{ $t("Templates") }}</h4>
                    <span class="templates-block__header-counter" v-if="!isShowFormTemplate" :class="{animate: !isShowFormTemplate}">{{ userTemplates.length }}</span>
                </div>
                <div class="templates-block__header-right">
                    <div class="templates-block__add-new" @click="addTemplate" v-if="!isShowFormTemplate" :class="{animate: !isShowFormTemplate}">
                        <svg v-once class="wc-i" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
                        <span>{{ !miniChat && !isMobile ? $t("Create new") : $t("New") }}</span>
                    </div>
                    <div class="templates-block__header-close" @click="handleClose">
                        <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                    </div>
                </div>
                
            </div>
            <div class="templates-block__slider" :class="['templates-' + userTemplates.length, {list: !isShowFormTemplate}]">
                <div class="templates-block__form" :class="{'mini': miniChat, active: isShowFormTemplate}">
                    <form @submit.prevent="submitForm" novalidate>
                        <InputGroup
                            type="text"
                            v-model="title"
                            :placeholder="$t('Template title')"
                            :maxLength="200"
                            required
                            inputClass="username-input"
                            :errorMessage="errorTitle"
                        />
                        <InputGroup
                            type="text"
                            v-model="description"
                            :placeholder="$t('Write your message here..')"
                            :maxLength="5000"
                            fieldType='textarea'
                            required
                            inputClass="username-input"
                            :errorMessage="errorMessage"
                        />
                        <Button
                            type="submit"
                            :buttonText="isEdit ? $t('Update template') : $t('Add new template')"
                            :isFormChanged="checkFormChange"
                            :showPreloader="showPreloader"
                            additionalClasses="template-btn"
                            colorClass="gray"
                        />
                    </form>  
                </div>
                <div class="templates-block__wrap" :class="{ active: !isShowFormTemplate }">
                    <ScrollFade class="templates-block__wrap-scroll" fade-top-class="faded-top" fade-bottom-class="faded">
                        <div class="template" v-for="(template) in userTemplates" :key="template.id" @click="choseTemplate(template.content)">
                            <div class="template__text">
                                <span class="template__text-title">{{template.title}}</span>
                                <span class="template__text-content" v-html="escapeHtml(template.content)"></span>
                            </div>
                            <div class="template__btns">
                                <div class="btn-edit" @click.stop="addTemplate(template.id)">
                                    <svg v-once class="wc-i" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"/></svg>
                                </div>
                                <div class="btn-delete" @click.stop="deleteTemplate(template.id)">
                                    <svg v-once class="wc-i" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>  
                                </div>
                            </div>
                        </div>
                    </ScrollFade>
                </div>
            </div>
        </SlideUpDown>
    </div>
  </template>
  <script>

  import ScrollFade from '/webpack-assets/vue/components/ScrollFade.vue';
  import axios from '/webpack-assets/vue/config/axios-config';
  import Button from '/webpack-assets/vue/components/Button.vue';
  import InputGroup from '/webpack-assets/vue/components/InputGroup.vue';
  import SlideUpDown from '/webpack-assets/vue/templates/chat/parts/ChatSlideUpDown.vue';
  import { escapeHtml } from '/webpack-assets/vue/utils/escapeHtml.js';

    export default {
        data() {
            return {
                userId: window.common.user.id,
                userTemplates: [],
                editTemplate: null,
                isShowFormTemplate: false,
                isFormVisible: false,
                defaultHeight: null,
                contentHeight: 0,
                templateId: '',
                classHeights: '',
                title: '',
                description: '',
                errorTitle: '',
                errorMessage: '',
                isEdit: false,
                titleTextNew: this.$t('New template'),
                titleTextEdit: this.$t('Edit template'),
                showPreloader: false,
            };
        },
        components: {
            ScrollFade,
            Button,
            InputGroup,
            SlideUpDown
        },
        props: {
            isActiveTemplates: {
                type: Boolean,
                default: false,
            },
            miniChat: {
                type: Boolean,
                default: false
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            setTimeout(() => {
                this.getTemplates()
            }, 400);
        },
        computed: {
            checkFormChange() {
                const title = this.title || '';
                const description = this.description || '';

                if (title.trim() !== '') {
                    this.errorTitle = '';
                }
                if (description.trim() !== '') {
                    this.errorMessage = '';
                }

                if (this.isEdit) {
                    return (this.editTemplate?.title !== this.title && title.trim() !== '') || (this.editTemplate?.content !== this.description && description.trim() !== '')
                } else {
                    return title.trim() !== '' && description.trim() !== ''
                }
            },
        },
        watch: {
            isActiveTemplates(bool) {
                this.isShowFormTemplate = this.userTemplates.length === 0;
                if(!this.isShowFormTemplate) {
                    this.classHeights = '';
                }
            }
        },
        methods: {
            escapeHtml,
            handleClose() {
                this.$emit('open-templates', false);
                this.classHeights = ''
            },
            handleOpenFormTemplates({ isOpen, editTemplateId = null, editTemplateTitle = null, editTemplateContent = null }) {
                this.isShowFormTemplate = isOpen;
                this.isEdit = !!editTemplateId;
                if (editTemplateId) {

                    this.templateId = editTemplateId;
                    this.title = editTemplateTitle;
                    this.description = editTemplateContent;
                } else {
                    this.title = '';
                    this.description = '';
                }
            },
            async deleteTemplate(id) {
                const el = this.$refs.slideUpDownRef?.$el || this.$refs.slideUpDownRef;
                const formData = new FormData();
                formData.append('_ts', Date.now());
                formData.append('id', id);

                try {
                    const response = await axios.post('/chat-api/remove-template', formData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (response.data.data) { 
                        this.userTemplates = this.userTemplates.filter(template => template.id !== id);
                        this.classHeights = ''
                        if( this.userTemplates.length === 0) {
                            this.$emit('open-templates', false);
                        } else if( this.userTemplates.length === 1) {
                            this.classHeights = 'template-1'
                        } else if( this.userTemplates.length === 2) { 
                            this.classHeights = 'template-2'
                        } else if( this.userTemplates.length === 3) {
                            this.classHeights = 'template-3'
                        } else if( this.userTemplates.length === 4) {
                            this.classHeights = 'template-4'
                        }
                    } else {
                        console.error('Failed to delete template:', response.data.message);
                    }
                } catch (error) {
                    console.error('Request failed:', error);
                }
            },
            choseTemplate(text) {
                this.$emit('chose-template', text);
                this.$emit('open-templates', false);
            },
            addTemplate(id = null) {
                this.isShowFormTemplate = true;
                this.editTemplate = id ? this.userTemplates.find(template => template.id === id) : null;

                this.isEdit = id !== null;
                this.handleOpenFormTemplates({
                    isOpen: true,
                    editTemplateId: this.editTemplate?.id,
                    editTemplateTitle: this.editTemplate?.title,
                    editTemplateContent: this.editTemplate?.content
                });
            },
            async getTemplates() {
                try {
                    const response = await axios.get('/chat-api/get-templates');

                    if (response?.data?.status !== 'success') {
                        console.warn('getTemplates invalid response:', response?.data);
                        return;
                    }

                    this.userTemplates = response.data.data || [];
                    this.isShowFormTemplate = false;

                    const count = this.userTemplates.length;

                    switch (true) {
                        case count <= 1:
                            this.classHeights = 'template-1';
                            break;

                        case count === 2:
                            this.classHeights = 'template-2';
                            break;

                        case count === 3:
                            this.classHeights = 'template-3';
                            break;

                        case count === 4:
                            this.classHeights = 'template-4';
                            break;

                        default:
                            this.classHeights = 'template-5';
                            break;
                    }

                } catch (error) {
                    if (
                        error?.code === 'ERR_NETWORK' ||
                        error?.message?.includes('Network Error')
                    ) {
                        console.warn('getTemplates network error ignored');
                        return;
                    }

                    console.warn('getTemplates error:', error);
                }
            },
            formatNumber(number) {
                return number
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            },
            async submitForm() {
                if (!this.title.trim() || !this.description.trim()) {
                    if(!this.title.trim()) {
                        this.errorTitle = this.$t('{title} cannot be blank', {title: this.$t('Template name')} );
                    }
                    if(!this.description.trim()) {
                        this.errorMessage = this.$t('{title} cannot be blank', {title: this.$t('Message')} );
                    }
                    return;
                }

                if(this.isEdit && !this.checkFormChange) return;
                this.showPreloader = true;
                const url = this.isEdit ? '/chat-api/update-template/' + this.templateId : '/chat-api/add-template';

                try {
                    const response = await axios({
                        method: 'post',
                        url: url,
                        data: { title: this.title, content: this.description}
                    });

                    if (response.data.status === "success") {
                        this.showPreloader = false;
                        this.getTemplates()
                        this.title = '';
                        this.description = '';
                        this.templateId = '';
                    }
                } catch (error) {
                    console.error('Request failed:', error.response?.data || error.message);
                }
            }
        },
    };
  </script>

<style lang="scss" scoped>
.templates-info-enter-active,
.templates-info-leave-active {
    transition: 0.5s ease;
    width: 100%;
}

.templates-info-enter-from,
.templates-info-leave-to {
    width: 0;
    opacity: 0;
}

.templates-info-enter-to,
.templates-info-leave-from {
    width: 100%;
    opacity: 1;
}
  .templates-block{
    overflow: hidden;
    width: 100%;
    z-index: 4;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    &.template-1{
        max-height: 138px !important;
    }
    &.template-2{
        max-height: 202px !important;
    }
    &.template-3{
        max-height: 268px !important;
    }
    &.template-4{
        max-height: 330px !important;
    }
    &.template-5{
        max-height: 376px !important;
    }
    &.form-active{
        max-height: 463px !important;
    }
    // SlideUpDown keeps the height measured on first open as an inline max-height;
    // cap the open panel instead so validation messages never clip the form
    &.default-active{
        max-height: 463px !important;
    }
    &__header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        flex: none;
        padding: 0 8px 0 16px;
        border-radius: 12px 12px 0 0;
        background-color: transparent;
        border-bottom: 1px solid var(--wc-surface-2);
        &-back{
            width: 32px;
            height: 32px;
            margin-left: -8px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: opacity 0.3s;
            opacity: 0;
            &:hover{
                background: var(--wc-bg);
            }
            &.animate{
                opacity: 1;
            }
        }
        &-title{
            display: flex;
            align-items: center;
            gap: 8px;
            h4{
                margin: 0;
                font-family: var(--wc-font-heading);
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: var(--wc-text);
                transition: opacity 0.3s;
                opacity: 0;
                &.animate{
                    opacity: 1;
                }
            }
        }
        &-counter{
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            background-color: var(--wc-accent-soft);
            font-family: var(--wc-font-medium);
            font-weight: 400;
            font-size: 11px;
            line-height: 20px;
            text-align: center;
            color: var(--wc-accent);
            border-radius: 10px;
            transition: opacity 0.3s;
            opacity: 0;
            &.animate{
                opacity: 1;
            }
        }
        &-right{
            display: flex;
            align-items: center;
            gap: 4px;
        }
        &-close{
            background-color: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 6px;
            cursor: pointer;
            transition: 0.2s;
            svg{
                width: 18px;
                height: 18px;
            }
            &:hover{
                background: var(--wc-bg);
            }
        }
    }
    &__slider{
        display: flex;
        width: 100%;
        transition: 0.5s ease;
        // form height follows its content (validation messages included)
        height: auto;
        max-height: 380px;
        &.list{
            height: 320px;
        }
        &.list.templates-1{
            height: 81px;
        }
        &.list.templates-2{
            height: 146px;
        }
        &.list.templates-3{
            height: 212px;
        }
        &.list.templates-4{
            height: 277px;
        }
    }
    &__form{
        flex-shrink: 0;
        opacity: 0;
        width: 0;
        transition: 0.5s ease;
        &.active{
            width: 100%;
            opacity: 1;
        }
        &.mini{
            form{
            }
        }
        min-height: 0;
        form{
            width: 100%;
            max-height: 100%;
            padding: 12px 16px 16px;
            overflow-y: auto;
            transition: 0.4s;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
        .template-btn{
            align-self: flex-end;
            width: auto;
            height: 36px;
            margin: 0;
            padding: 0 16px;
            max-width: 100%;
            border: 0;
            background-color: #2F6BE6 !important;
            color: var(--wc-on-accent) !important;
            border-radius: 8px;
            text-transform: none;
            span{
                font-family: var(--wc-font-medium);
                font-size: 13px;
                color: var(--wc-on-accent);
                text-transform: none;
            }
            &.not-changed{
                background-color: #EEF0F3 !important;
                opacity: 1;
                color: #6B7280 !important;
                span{
                    color: #6B7280 !important;
                }
            }
        }
        :deep(.form-input) {
            border-radius: 12px;
        }
        :deep(.form-input-border){
            border-radius: 12px;
        }
        :deep(.form-input-border::before){
            border-radius: 12px 12px 0 0 !important;
        }
        :deep(.form-input-border::after){
            border-radius: 0 0 12px 12px !important;
            transform: rotate(0) !important;
        }
    }
    &__wrap{
        width: 0;
        flex-shrink: 0;
        opacity: 0;
        transition: 0.5s ease;
        &.active{
            width: 100%;
            opacity: 1;
        }
        &-scroll{
            width: 100%;
            max-height: 320px;
            transition: 0.4s;
            padding: 4px;
        }
        .template{
            overflow: hidden;
            padding: 8px 4px 8px 12px;
            background-color: transparent;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 8px;
            margin-bottom: 0;
            min-width: 0;
            width: 100%;
            transition: 0.2s;
            &:hover{
                background-color: var(--wc-bg);
                .template__btns{
                    opacity: 1 !important;
                }
                .template__text{
                    min-width: 0;
                }
            }
            &__btns{
                opacity: 0;
                display: flex;
                align-items: center;
                gap: 4px;
                min-width: 68px;
                padding-left: 8px;
                transition: 0.3s;
                .btn-edit,
                .btn-delete{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: transparent;
                    width: 32px;
                    height: 32px;
                    border-radius: 6px;
                    cursor: pointer;
                    &:hover{
                        background-color: var(--wc-surface-2);
                    }
                    svg{
                        path{
                            transition: 0.3s;
                        }
                    }
                    &:hover{
                        svg{
                            path{
                                fill: var(--wc-text);
                            }
                        }
                    }
                }
            }
            &__text{
                max-width: 100%;
                width: 100%;
                min-width: auto;
                display: flex;
                flex-direction: column;
                gap: 2px;
                &-title{
                    font-family: var(--wc-font-medium);
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 18px;
                    color: var(--wc-text);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                &-content{
                    font-family: var(--wc-font);
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    color: var(--wc-text-2);
                    width: 100%;
                    overflow: hidden;
                    -webkit-mask-image: linear-gradient(90deg, black 90%, transparent);;
                    white-space: nowrap;
                    width: 100%;
                }
            }
        }
    }
    &__add-new{
        background-color: var(--wc-surface);
        border: 1px solid var(--wc-border);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        padding: 0 10px;
        gap: 6px;
        cursor: pointer;
        border-radius: 8px;
        transition: 0.3s;
        opacity: 0;
        &.animate{
            opacity: 1;
        }
        &:hover{
            background-color: var(--wc-surface-2);
        }
        svg{
            width: 16px;
            height: 16px;
        }
        span{
            font-family: var(--wc-font-medium);
            font-weight: 400;
            font-size: 13px;
            line-height: 18px;
            text-align: center;
            color: var(--wc-text);
        }
    }
  }
</style>